import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalender5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calender-5,date"} maskId="square-filled-radius-0-stroke-1-IconCalender5"><path d="M16 3H8V5H7V3H3V7H21V3H17V5H16V3Z" fill="currentColor"/><path d="M21 8H3V21H21V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalender5;
